import { PollCardProps } from './types';

export const PollCard = ({ children }: PollCardProps) => <div className="flex flex-1 items-start">{children}</div>;
